import baseAntLocaleAz from 'antd/lib/locale/az_AZ';

const antLocaleAz = { ...baseAntLocaleAz, Modal: { okText: 'Təsdiqlə', cancelText: 'Bağla', justOkText: 'Təsdiqlə' } };

export default antLocaleAz;
